<template>
  <div class="flex flex-wrap flex-1 -mx-4 event-card">
    <div
      v-for="(event, index) in events"
      :key="event.id"
      class="flex flex-col w-full max-w-sm mx-auto mb-12 md:mx-0 md:w-1/2 lg:w-1/3 xl:w-1/4"
    >
      <div class="mx-4 bg-white rounded shadow">
        <router-link :to="{ name: 'event.track.search', params: { id: event.id} }">
          <div class="overflow-hidden rounded-t event-image">
            <img
              :src="getEventPlaceholderImage(event)"
              class="object-cover object-center w-full h-48"
            >
          </div>
        </router-link>
        <div class="flex flex-col px-2 py-3 event-card__body">
          <div class="flex items-baseline mb-1 event-meta">
            <span class="mr-8 text-sm font-semibold text-gray-800 uppercase">
              {{ event.playlist.tracks.length }} Tracks
            </span>
            <span class="text-xs text-gray-700">
              {{ event.starts_on }}
            </span>
          </div>
          <div class="mb-12 text-2xl truncate event-name semibold">
            {{ event.name }}
          </div>
          <div class="flex justify-between event-actions">
            <mj-button
              v-clipboard="guestsUrl + event.sub_user.token"
              v-clipboard:success="clipboardSuccessHandler"
              v-clipboard:error="clipboardErrorHandler"
              class="text-xs btn-flat-secondary"
              type="button"
              @click="setCurrentClipboardEvent(event)"
            >
              Teilen
            </mj-button>
            <mj-drop-down
              ref="eventOptionsDropDown"
              direction="right"
            >
              <button
                class="focus:outline-none"
                type="button"
                @click="showCollabsibleContent(index)"
              >
                <mj-icon
                  src="more-horizontal"
                  class="w-5 h-5"
                />
              </button>
              <template #collapsible>
                <div class="w-64 overflow-hidden text-base font-semibold text-left text-gray-900 bg-white rounded-lg shadow-lg">
                  <div class="py-1 actions">
                    <button
                      v-can="'edit events'"
                      class="block w-full px-6 py-3 font-semibold text-left outline-none hover:bg-indigo-100 focus:outline-none"
                      @click="showModal(index, 'update')"
                    >
                      Bearbeiten
                    </button>
                    <button
                      v-can="'delete events'"
                      class="block w-full px-6 py-3 font-semibold text-left outline-none hover:bg-indigo-100 focus:outline-none"
                      @click="showModal(index, 'delete')"
                    >
                      Löschen
                    </button>
                  </div>
                </div>
              </template>
            </mj-drop-down>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGuestUrl } from '@/helpers';
import DropDown from '@/components/ui/general/dropdown/DropDown.vue';
import ShareService from '@/services/ShareService';
import FeedbackService from '@/services/FeedbackService';

export default {

  components: {
    'mj-drop-down': DropDown,
  },

  props: {
    events: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  data() {
    return {
      currentClipboardEvent: {},
    };
  },

  computed: {
    guestsUrl() {
      return getGuestUrl();
    },
  },

  methods: {
    setCurrentClipboardEvent(event) {
      this.currentClipboardEvent = event;
    },
    clipboardSuccessHandler({ value, event }) {
      FeedbackService.addCopyToClipboardNotification(event);
      ShareService.viaWhatsapp(value, this.currentClipboardEvent.name);
    },

    clipboardErrorHandler({ value }) {
      console.log('error', value);
    },

    showCollabsibleContent(index) {
      this.$refs.eventOptionsDropDown[index].$data.isOpen = true;
    },

    closeCollabsibleContent(index) {
      this.$refs.eventOptionsDropDown[index].$data.isOpen = false;
    },

    showModal(index, mode) {
      const name = mode === 'delete' ? 'mj-event-delete-modal' : 'mj-event-save-modal';
      this.$modal.show('root-modal', { name, event: this.events[index], mode });
      this.closeCollabsibleContent(index);
    },

    getEventPlaceholderImage(event) {
      const asset = event.assets.find(a => a.type === 'event_placeholder');

      if (asset && asset.image) {
        return `data:image/png;base64, ${asset.image}`;
      }
      return 'https://placehold.it/400x200';
    },
  },

};

</script>
